import { defaultLogger as defaultLogger$1, tracerLogger as tracerLogger$1, logFmtLogger } from '../../internal/fiberRuntime.esm.js';
import { addLogger, addLoggerEffect, addLoggerScoped, removeLogger, replaceLogger, replaceLoggerEffect, replaceLoggerScoped, withMinimumLogLevel as withMinimumLogLevel$1, minimumLogLevel as minimumLogLevel$1 } from '../../internal/layer/circular.esm.js';
import { LoggerTypeId as LoggerTypeId$1, makeLogger, mapInput as mapInput$1, filterLogLevel as filterLogLevel$1, map as map$1, none as none$1, simple as simple$1, succeed as succeed$1, sync as sync$1, zip as zip$1, zipLeft as zipLeft$1, zipRight as zipRight$1, logfmtLogger as logfmtLogger$1, stringLogger as stringLogger$1 } from '../../internal/logger.esm.js';
import { test as test$1 } from '../../internal/logger-circular.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const LoggerTypeId = LoggerTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const make = makeLogger;

/**
 * @since 2.0.0
 * @category context
 */
const add = addLogger;

/**
 * @since 2.0.0
 * @category context
 */
const addEffect = addLoggerEffect;

/**
 * @since 2.0.0
 * @category context
 */
const addScoped = addLoggerScoped;

/**
 * @since 2.0.0
 * @category mapping
 */
const mapInput = mapInput$1;

/**
 * Returns a version of this logger that only logs messages when the log level
 * satisfies the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
const filterLogLevel = filterLogLevel$1;

/**
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * A logger that does nothing in response to logging events.
 *
 * @since 2.0.0
 * @category constructors
 */
const none = none$1;

/**
 * @since 2.0.0
 * @category context
 */
const remove = removeLogger;

/**
 * @since 2.0.0
 * @category context
 */
const replace = replaceLogger;

/**
 * @since 2.0.0
 * @category context
 */
const replaceEffect = replaceLoggerEffect;

/**
 * @since 2.0.0
 * @category context
 */
const replaceScoped = replaceLoggerScoped;

/**
 * @since 2.0.0
 * @category constructors
 */
const simple = simple$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const succeed = succeed$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const sync = sync$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const test = test$1;

/**
 * @since 2.0.0
 * @category context
 */
const withMinimumLogLevel = withMinimumLogLevel$1;

/**
 * Combines this logger with the specified logger to produce a new logger that
 * logs to both this logger and that logger.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip = zip$1;

/**
 * @since 2.0.0
 * @category zipping
 */
const zipLeft = zipLeft$1;

/**
 * @since 2.0.0
 * @category zipping
 */
const zipRight = zipRight$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const defaultLogger = defaultLogger$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const logfmtLogger = logfmtLogger$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const stringLogger = stringLogger$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const tracerLogger = tracerLogger$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const logFmt = /*#__PURE__*/replace(defaultLogger$1, logFmtLogger);

/**
 * @since 2.0.0
 * @category context
 */
const minimumLogLevel = minimumLogLevel$1;

export { LoggerTypeId, add, addEffect, addScoped, defaultLogger, filterLogLevel, logFmt, logfmtLogger, make, map, mapInput, minimumLogLevel, none, remove, replace, replaceEffect, replaceScoped, simple, stringLogger, succeed, sync, test, tracerLogger, withMinimumLogLevel, zip, zipLeft, zipRight };
